import React, { useState } from "react";
import { LaravelDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const LaravelDevelopers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire skilled Laravel developers in India to build secure, scalable, and high-performing web applications. Get expert Laravel development tailored to your business needs."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Skilled Laravel Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-laravel-developers"/>
<meta property="og:description" content="Hire skilled Laravel developers in India to build secure, scalable, and high-performing web applications. Get expert Laravel development tailored to your business needs."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Skilled Laravel Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire skilled Laravel developers in India to build secure, scalable, and high-performing web applications. Get expert Laravel development tailored to your business needs."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-laravel-developers"/>
<title>Hire Skilled Laravel Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className=" flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16  mt-6">
          <div className="lg:w-3/4 lg:text-left ">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Skilled Laravel Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              Laravel is a powerful PHP framework that provides essential tools
              for developing robust and feature-rich applications. With its
              excellent inversion of control container, seamless migration
              capabilities, and integrated unit testing, Laravel has established
              itself as a leading framework for building high-functionality web
              applications.
              <br />
              <br />
              Hire experienced Laravel developers who can flawlessly handle your
              projects. At Ayanshtech, our dedicated Laravel developers excel in
              web application development, leveraging their in-depth knowledge
              and expertise to build applications of varying sizes and
              complexities using the Laravel framework.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $10/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a Laravel Developer
            </button>
          </div>

          <div className="flex justify-center mb-10  mt-5">
            <img
              src="\assets\images\headerSection\hireLaravelDev\img1.webp"
              alt="VoIP Business Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5  p-4">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Our Laravel Developer's Areas of Expertise
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          With extensive technical proficiency, our Laravel specialists excel in
          managing complex and large-scale Laravel development projects across
          multiple domains.
        </p>
      </div>

      <div className="  ml-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon11.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">API and Module Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon12.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Porting and Migration</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon13.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">CMS Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon14.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Maintenance and Testing</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon15.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">CRM and ERP Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon16.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Social Networking Solution</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon17.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">eCommerce Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon18.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Extension Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon19.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Customized Laravel Web Development</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Expert Laravel Professionals
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Collaborate with highly skilled Laravel developers who can seamlessly
          integrate with your team or help establish a new technical unit.
        </p>
      </div>

      <div className=" ">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hireLaravelDev\img2.webp"
              alt="Graph on a laptop screen"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Access a pool of experienced Laravel developers ready to be
                  hired for your specific needs.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Rigorous vetting processes ensure you hire only top Laravel
                  developers for your projects.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Dedicated developers provide daily updates during your working
                  hours for complete transparency.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Tailored hiring models designed to suit your budget and
                  project requirements.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our technical consultants assist in shortlisting and
                  interviewing candidates to find the perfect Laravel expert for
                  your team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      <div className="max-w-3xl mx-auto p-6 w-full ">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8  ">
          FAQs
        </h2>
        {LaravelDevFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
      <div id="contact-section">
        {" "}
        <Contact />
      </div>
      <GetInTouch />
    </div>
  </>);
};

export default LaravelDevelopers;
